import { useEffect } from "react";

import { getResponsiveHeaderHeight } from "@components/store/navigation/multi-level-header/responsive";

import { disableScroll, enableScroll } from "@stadium/helpers/animate";

import styles from "./main.module.scss";

const NavSlider = ({ isMobileNavOpen, children, customClass = "" }) => {
  const headerActiveClass = isMobileNavOpen ? styles.responsiveSlideHeaderShow : "";

  useEffect(() => {
    if (isMobileNavOpen) {
      disableScroll(document.body, { addTopMargin: false });
    } else {
      enableScroll(document.body);
    }
  }, [isMobileNavOpen]);

  return (
    <header
      className={`${styles.responsiveSlideHeader} ${headerActiveClass} ${customClass}`}
      style={{ "--sticky-header-height": getResponsiveHeaderHeight(isMobileNavOpen) }}
    >
      {children}
    </header>
  );
};

export default NavSlider;
